import { CATEGORIES_FETCHED, FETCHING_CATEGORIES } from '../actions/';

const initState = { loading: true, response: null, list: [] };

export default function (state = initState, action) {
	switch (action.type) {
    case FETCHING_CATEGORIES:
      return {...state, response: null, list: [], loading: true}
		case CATEGORIES_FETCHED:
			return { ...state, response: action.payload, list: action.payload.data,  loading: false };
		default:
			return state;
	}
}
